import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import ApplyImg from '../images/Apply Now_1.jpg'
import ExistCustomer from '../images/Existing_Customers.jpg'
import CanMoney from '../images/payday-payday-loans-ca-4.jpg'

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:''};				
	}

	componentDidMount() {				
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	render() {		
		return(
			<div>
				<CommonHeader titles="Patday Loan Cash Advance"/>				
				<h1 className="headings" style={{textAlign:"center",color:"green"}}><small>{this.state.CompName}--Payday Loan Provider for Canadians</small></h1>				
				<div id="contentwrapper" >
					<div id="contentcolumn">
						<Link className="applybutton" to = "/Apply"><img border="0" src={ApplyImg} alt="Payday loans application"/></Link>
						<Link className="applybutton" to = "/Member"><img border="0" src={ExistCustomer} alt="Payday loans Returning Customers"/></Link>
					</div>
				</div>
				<div id="rightcolumn">
					<div className="innertext">
						<b style={{color:"green"}}>No Fax</b><br/>
						<b style={{color:"green"}}>Fast and Easy</b><br/>
						<b style={{color:"green"}}>No hidden cost</b><br/>
						<b style={{color:"green"}}>No Credit Check</b><br/>
						<b style={{color:"green"}}>Up to $600 until next pay day</b><br/>
						<b style={{color:"green"}}>Cash advance deposited directly to your account</b><br/>
					</div>
				</div>
				<div id="leftcolumn" title="Your payday loans"><img src={CanMoney} alt="Your Payday loans and cash advance"/></div>
				<div id="bottom"><br/>
				<h1 style={{color:"blue"}}>Cash Advance--Simple, Easy and Fast</h1>					
				<h4 style={{color:"grey"}}>A Cash advance on your next payday is also commonly called a payday loan or Payroll loan. If you were in a financial pinch, you needed the money to cover 
					an emergnecy expense or you're looking for some extra money until your next payday in case you just don't have enough money in your pocket, well you've 
					come to the right place. A Cash Advance could help you with your car reparis, sudden bills and a necessary travle in case your loved one is sick. 
					Even a Cash Advance could help you avoid a bank overdraft fees, which are expensive and add up over time.</h4>
				<h4 style={{color:"grey"}}>{this.state.CompName} has provided its customers with fast cash using its faxless, online payday loan application system to get the money you need to avoid 
					expenses like bounced cheque fees or bank overdraft fees. Fill out the online application just in minutes and if approved, get the funds deposited directly 
					into your provided banking account.</h4>
				<h4 style={{color:"grey"}}>If you are 18 years of age (minimum applicant age for our payday loans) or above and locating in Canada, you are welcome to use our friendly services. 
					No hassle, no credit check required, no misleading, no hidden cost. We are always willing to be a support. If you are ready to experience the simplest 
					payday loan online then all you need to do is click here to start your application.</h4>
				<h4 style={{color:"grey"}}>Unfortunately We don't lend Cash Advance to applicants who are seasonally/temporarily employed or on social assistance. The final decision on all applications 
					is subject to the sole discretion of {this.state.CompName}.</h4>					
				<h1 style={{color:"#0040ff"}}><Link style={{color:"#0040ff"}} to = "/Apply">Apply Now!</Link> Get approved today!</h1>
				</div>
				<br/>					
			</div>
		)
	}
}

export default HomtContents